import $http from "../axios";

const state = {
  //feedbacks: []
};

const getters = {};

const actions = {
  getClients(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-clients`, { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
